import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IDNASample } from "../interfaces/dna-sample";
import { IDNASampleSearchResult } from '../interfaces/dna-sample-search-result';
import { IDuplicateDNASampleResult } from "../interfaces/duplicate-dna-sample-result";
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { IGetSampleTempIdResult } from '../interfaces/get-sample-temp-id-result';

@Injectable({
  providedIn: 'root'
})
export class DNASampleService {
  private rootUrl: string = "/api/dna-samples";

  public constructor(private httpClient: HttpClient) { }

  public searchDNASamples(lastName: string, firstName: string, ssn: string, sid: string, docNumber: string, docNumberVisible: boolean): Observable<IDNASampleSearchResult[]> {
    let lastNameQuery = lastName ? "&lastName=" + lastName : "";
    let firstNameQuery = firstName ? "&firstName=" + firstName : "";
    let ssnQuery = ssn ? "&ssn=" + ssn : "";
    let sidQuery = sid ? "&sid=" + sid : "";
    let docNumberQuery = docNumber ? "&docNumber=" + docNumber : "";
    let docNumberVisibleQuery = docNumberVisible ? "&docNumberVisible=true" : "";

    const url = this.rootUrl + "?resultCountLimit=" + environment.dnaSearchResultCountLimit + lastNameQuery + firstNameQuery + ssnQuery + sidQuery + docNumberQuery + docNumberVisibleQuery;
    return this.httpClient.get<IDNASampleSearchResult[]>(url);
  }

  public getDNASampleTempId(id: number): Observable<IGetSampleTempIdResult> {
    const url = this.rootUrl + "/" + id + "/temp-id";
    return this.httpClient.get<IGetSampleTempIdResult>(url);
  }

  public getDNASample(tempId: string): Observable<IDNASample> {
    const url = this.rootUrl + "/" + tempId;
    return this.httpClient.get<IDNASample>(url);
  }

  public isDuplicate(lastName: string, firstName: string, dateOfBirth: NgbDateStruct, ssn: string, sid: string, docNumber: string): Observable<IDuplicateDNASampleResult[]> {
    if (lastName === null) lastName = "";
    if (firstName === null) firstName = "";
    let dobString = dateOfBirth === null ? "" : this.formatNgbDate(dateOfBirth);
    if (ssn === null) ssn = "";
    if (sid === null || sid === "VA") sid = "";
    if (docNumber === null) docNumber = "";

    const url = this.rootUrl + "/is-duplicate?lastName=" + lastName + "&firstName=" + firstName + "&dateOfBirth=" + dobString + "&ssn=" + ssn + "&sid=" + sid + "&docNumber=" + docNumber;
    return this.httpClient.get<IDuplicateDNASampleResult[]>(url);
  }

  private formatNgbDate(date: NgbDateStruct): string {
    var month = date.month < 10 ? "0" + date.month.toString() : date.month.toString();
    var day = date.day < 10 ? "0" + date.day.toString() : date.day.toString();
    return date.year.toString() + "-" + month + "-" + day;
  }
}
